import { graphql } from '@warehouse/graphql';
import { gql } from '@apollo/client';

export const SEARCH_RELATIONSHIPS = graphql(`
	query searchRelationships($search: SearchInput!) {
		searchRelationships(search: $search) {
			documents {
				direction
				indexed {
					...TitleIndexedFragment
				}
				relationship {
					...RelationshipFragment
				}
				state
				titleUuid
				uuid
			}
			page {
				currentPage
				perPage
				totalDocument
				totalPage
			}
		}
	}
`);

export const SEARCH_RELATIONSHIPS_CHILDREN_TAB = graphql(`
	query searchRelationshipsChildrenTab($search: SearchInput!) {
		searchRelationships(search: $search) {
			documents {
				indexed {
					workType {
						uuid
					}
				}
				relationship {
					type
				}
			}
		}
	}
`);

export const SEARCH_CHILDREN_RELATIONSHIP_TYPES = gql`
	query searchChildrenRelationshipTypes(
		$seasons: SearchInput!
		$episodes: SearchInput!
		$entries: SearchInput!
		$edits: SearchInput!
		$manifestations: SearchInput!
	) {
		seasons: searchRelationships(search: $seasons) {
			documents {
				relationship {
					type
				}
			}
		}
		episodes: searchRelationships(search: $episodes) {
			documents {
				relationship {
					type
				}
			}
		}
		entries: searchRelationships(search: $entries) {
			documents {
				relationship {
					type
				}
			}
		}
		edits: searchRelationships(search: $edits) {
			documents {
				relationship {
					type
				}
			}
		}
		manifestations: searchRelationships(search: $manifestations) {
			documents {
				relationship {
					type
				}
			}
		}
	}
`;
